/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Session_Limit_LabelInputs */

const en_us2_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That time is…`)
};

const pt_br2_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse tempo é…`)
};

const es_419_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese tiempo es…`)
};

const pt_pt2_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse tempo é…`)
};

const fr_fr2_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette durée est…`)
};

const de_de2_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Zeit ist…`)
};

const it_it2_profile_editors_session_limit_label = /** @type {(inputs: Profile_Editors_Session_Limit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo tempo è…`)
};

/**
* | output |
* | --- |
* | "That time is…" |
*
* @param {Profile_Editors_Session_Limit_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_session_limit_label = /** @type {((inputs?: Profile_Editors_Session_Limit_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Session_Limit_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_session_limit_label(inputs)
	if (locale === "es-419") return es_419_profile_editors_session_limit_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_session_limit_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_session_limit_label(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_session_limit_label(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_session_limit_label(inputs)
	return en_us2_profile_editors_session_limit_label(inputs)
});
export { profile_editors_session_limit_label as "profile-editors.session_limit_label" }